import { render, staticRenderFns } from "./QuerySent.vue?vue&type=template&id=6f3f88ba&lang=pug&"
import script from "./QuerySent.vue?vue&type=script&lang=js&"
export * from "./QuerySent.vue?vue&type=script&lang=js&"
import style0 from "./QuerySent.vue?vue&type=style&index=0&id=6f3f88ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports